/** See i18n.options.ns for the @default value */
export const I18N_DEFAULT_NS = 'translation';
import '@emotion/react';
//# sourceMappingURL=types.js.map